// src/pages/ReadabilityTools/ReadabilityTools.js
import { useState } from 'react';
import { Box } from '@mui/material';
//import TabPanel from '../ContentDetail/components/TabPanel';
import Header from '../../components/Header';
import TabContainer from '../../components/TabContainer';
import TabNavBar from '../../components/TabNavBar';
import TextTranslationTab from '../../tabs/TextTranslationTab';
import TextLookupTab from '../../tabs/TextLookupTab';
import WordLookupTab from '../../tabs/WordLookupTab';
import GlyphLookupTab from '../../tabs/GlyphLookupTab';
import TabPanel from '../../../../components/common/TabPanel';

const ReadabilityTools = () => {

  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box >
      <Header />
      <TabContainer>
        <TabNavBar tabValue={tabValue} handleTabChange={handleTabChange} />
        <TabPanel value={tabValue} index={0}>
          <TextTranslationTab />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <TextLookupTab />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <WordLookupTab />
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
          <GlyphLookupTab />
        </TabPanel>
      </TabContainer>
    </Box>
  );
};

export default ReadabilityTools;